module.exports = __webpack_public_path__ + "static/media/payDayArr.1bce72e3.svg";